module.exports = __webpack_public_path__ + "img/quest_icon_0079_magic3.ecd9f8a3.png";